<template>
  <div class="container mt-2">
    <div class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <div v-if="streamLoaded" style="border: 1px solid #000; background: #000;">
          <video
            ref="videoEl"
            controls
            playsinline
            webkit-playsinline
            poster="/img/wakatoon-bg.jpg"
            style="width: 100%; display: block;"
          ></video>
        </div>
        <p
          class="text-center"
          style="margin-top: 10px; z-index: 1000"
          v-if="realStreamLoaded"
        >
          Votre dessin animé sera bientôt prêt...
        </p>
        <p class="text-center mt-5">
          Envie de wakatooner d'autres histoires à la maison ? <br />
          <a href="http://www.wakatoon.com/download" target="_blank">Téléchargez l'appli Wakatoon</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from 'hls.js';
import { GET_STREAM_LINK_ACTION } from "../../store/actions.type";

export default {
  name: "watch-video",
  data() {
    return {
      streamLoaded: false,
      realStreamLoaded: true,
      videoGenerationRequest: null,
      video_generation_rate: 0,
      video_ready_rate: 0,
      number_of_times: 0,
      hls: null,
      streamSrc: null,
    };
  },
  methods: {
    initPlayer(src) {
      this.$nextTick(() => {
        const video = this.$refs.videoEl;
        if (!video) return;

        if (this.hls) {
          this.hls.destroy();
          this.hls = null;
        }

        if (Hls.isSupported()) {
          const hls = new Hls({
            xhrSetup(xhr) {
              xhr.withCredentials = false;
            },
            manifestLoadingMaxRetry: 6,
            manifestLoadingRetryDelay: 1000,
            levelLoadingMaxRetry: 6,
            levelLoadingRetryDelay: 1000,
            fragLoadingMaxRetry: 6,
            fragLoadingRetryDelay: 1000,
          });

          hls.loadSource(src);
          hls.attachMedia(video);

          hls.on(Hls.Events.ERROR, (event, data) => {
            console.log('HLS error', data);
            if (data.fatal) {
              if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
                hls.startLoad();
              } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
                hls.recoverMediaError();
              } else {
                hls.destroy();
                this.hls = null;
              }
            }
          });

          this.hls = hls;
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Safari native HLS support
          video.src = src;
        }
      });
    },
  },
  watch: {
    streamLoaded(newVal) {
      if (newVal && this.streamSrc) {
        this.initPlayer(this.streamSrc);
      }
    },
  },
  beforeDestroy() {
    if (this.hls) {
      this.hls.destroy();
      this.hls = null;
    }
    if (this.videoGenerationRequest) clearInterval(this.videoGenerationRequest);
  },
  mounted() {
    let loader = this.$loading.show({
      container: null,
      canCancel: false,
    });

    let wakartistId = this.$route.query.wakartistId;
    let storyId = this.$route.query.storyId;
    let episodeId = this.$route.query.episodeId;
    let photoId = this.$route.query.photoId;

    this.$store
      .dispatch(GET_STREAM_LINK_ACTION, { wakartistId, storyId, episodeId, photoId })
      .then((data) => {
        this.video_generation_rate = data.video_generation_rate;
        this.video_ready_rate = data.video_ready_rate;
        console.log("video_generation_rate = " + this.video_generation_rate);

        if (this.video_ready_rate >= 100) {
          this.streamSrc = data.stream_link;
          this.realStreamLoaded = false;
          this.streamLoaded = true;
          loader.hide();
        } else {
          const vm = this;
          this.videoGenerationRequest = setInterval(function () {
            vm.$store
              .dispatch(GET_STREAM_LINK_ACTION, {
                wakartistId,
                storyId,
                episodeId,
                photoId
              })
              .then((d) => {
                vm.video_generation_rate = d.video_generation_rate;
                vm.video_ready_rate = d.video_ready_rate;
                console.log("video_generation_rate = " + vm.video_generation_rate);

                vm.number_of_times = vm.number_of_times + 1;

                if (vm.video_ready_rate >= 100) {
                  vm.streamSrc = d.stream_link;
                  vm.realStreamLoaded = false;
                  vm.streamLoaded = true;
                  loader.hide();
                  clearInterval(vm.videoGenerationRequest);
                } else {
                  if (vm.video_generation_rate >= 100) {
                    vm.streamSrc = d.stream_link;
                    vm.realStreamLoaded = true;
                    vm.streamLoaded = true;
                    loader.hide();
                    clearInterval(vm.videoGenerationRequest);
                  }
                  if (vm.number_of_times >= 18) {
                    loader.hide();
                    clearInterval(vm.videoGenerationRequest);
                    vm.$alert(
                      "Temps de chargement trop long. Veuillez réessayer SVP.",
                      "Erreur",
                      "error"
                    );
                  }
                }
              });
          }, 5000);
        }
      })
      .catch(() => {
        loader.hide();
        this.$alert(
          "Vidéo introuvable. Veuillez vérifier le lien de votre vidéo.",
          "Erreur",
          "error"
        );
      });
  },
};
</script>